import { render, staticRenderFns } from "./GlobalAlertWindow.vue?vue&type=template&id=7534224e&scoped=true&"
import script from "./GlobalAlertWindow.vue?vue&type=script&lang=js&"
export * from "./GlobalAlertWindow.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAlertWindow.vue?vue&type=style&index=0&id=7534224e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7534224e",
  null
  
)

export default component.exports